import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    ...theme.scrollbarStyles,
    overflowY: 'scroll',
    flex: 1
  },
  tab: {
        borderBottom:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    '& .MuiTab-root': {
      minHeight: '28px',
      minWidth: '110px',
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_600.main : theme.palette.gray_100.main,

    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .MuiTabScrollButton-root': {
      width: '25px'
    }
  },
  tabHeader: {
    // backgroundColor: theme.palette.blue_300.main,
    borderRadius: '8px 8px 0 0',
    margin: '12px 0 0 0',
    padding: '2px 4px',
    position: 'relative',
    zIndex: 1,
    // boxShadow: '0 2px 5px rgba(0,0,0,0.1)',

    '&.Mui-selected': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main,
      zIndex: 2,
      '& span': {
        color: theme.palette.white_100.main
      }
    }
  },
  paper: {
    ...theme.scrollbarStyles,
    overflowY: 'scroll',
    padding: '0 25px 25px 25px',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  container: {
    width: '100%',
    maxHeight: '100%'
  },
  control: {
    padding: theme.spacing(1)
  },
  textfield: {
    width: '100%'
  }
}))
